import { SECURITY_JWT_KEY } from "config/globals"

export const getToken = () => {
    return localStorage.getItem(SECURITY_JWT_KEY)
}
